import { useId } from 'react'
import './Select.css'

export function Select({ label, options = [], id, style, ...rest }) {
  const autoId = useId()
  const iid = id || autoId

  return (
    <div
      className="u-field"
      style={{ display: 'flex', flexDirection: 'column', gap: 6, ...style }}
    >
      {label && (
        <label htmlFor={iid} style={{ fontSize: 'var(--text-sm)', fontWeight: 600 }}>
          {label}
        </label>
      )}
      <select id={iid} className="u-select" {...rest}>
        {options.map((o) =>
          typeof o === 'string' ? (
            <option key={o} value={o}>
              {o}
            </option>
          ) : (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ),
        )}
      </select>
    </div>
  )
}

export default Select
